import React from 'react';
import { FormControl, Select, MenuItem, InputLabel } from '@mui/material';

export type LabeledSelectProps<T> = {
    label: string;
    disabled: boolean;
    options: T[];
    selected: T | undefined;
    onChange?: (value: T) => void;
    minWidth?: number | string;
} & (
        T extends string
        ? {
            getOptionValue?: (option: T) => string;
        }
        : {
            getOptionValue: (option: T) => string;
        }
    )

export function LabeledSelect<T>(props: LabeledSelectProps<T>) {
    const { label, disabled, options, selected, getOptionValue, onChange, minWidth = 120 } = props;

    return (
        <FormControl sx={{
            margin: theme => theme.spacing(1),
            minWidth,
        }}>
            <InputLabel id="list-item-label" >{label}</InputLabel>
            <Select
                displayEmpty
                labelId='list-item-label'
                disabled={disabled}
                value={selected ?? ''}
                autoWidth={true}
                onChange={e => onChange ? onChange(e.target.value as T) : undefined}
            >
                {
                    options.map((r, i) => {
                        const s = getOptionValue ? getOptionValue(r) : (r as unknown as string);
                        return <MenuItem key={i} value={r as unknown as string}>{s}</MenuItem>;
                    })
                }
            </Select>
        </FormControl >
    );
}
